import React from 'react';
import { connect } from 'react-redux';
import makeRequest from 'utils/makeRequest';
import { getValueBeforeDecimal } from 'utils/common';
import PropTypes from 'prop-types';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { bindGa } from 'helpers/analytics';
import { WEB_INDIA_HP_GA_CAT } from 'constants/index';
import s from './CoronaWidget.scss';

class CoronaWidget extends React.Component {
  constructor() {
    super();
    this.state = { apiData: {} };
  }
  componentDidMount() {
    this.fetchData();
  }

  getActiveFilter() {
    const { filterList } = this.state;
    if (!Array.isArray(filterList)) {
      return {};
    }
    return filterList.filter(item => item.active)[0] || {};
  }

  fetchData() {
    const { data: { dataUrl } } = this.props;
    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (data && typeof data.data === 'object') {
          this.apiData = data.data;
          this.apiData.World = data.data.Total;
          delete this.apiData.Total;
          const filterList = Object.keys(this.apiData).map(filter => {
            const title =
              typeof filter === 'string' ? filter.toLowerCase() : '';
            return {
              title: filter,
              active: title === 'india',
            };
          });
          this.setState({
            apiData: this.apiData.India,
            filterList,
          });
        }
      });
  }
  @bindGa({})
  onFilterSelect = (e, title = '') => {
    const { filterList } = this.state;
    if (!Array.isArray(filterList)) {
      return;
    }
    const currentFilter = filterList.filter(item => {
      const itemTitle =
        typeof item.title === 'string' ? item.title.toLowerCase() : '';
      return itemTitle === title.toLowerCase();
    });
    const gadata = {
      gaCategory: WEB_INDIA_HP_GA_CAT,
      gaAction: 'CoronaHPWidget',
      gaLabel: currentFilter[0].title,
    };
    sendGaThroughProps({ data: gadata });
    const data = this.apiData[currentFilter[0].title];
    const updatedFilterList = filterList.map(item => ({
      title: item.title,
      active: currentFilter[0].title === item.title,
    }));
    this.setState({
      apiData: data,
      filterList: updatedFilterList,
    });
    this.toggleFilters();
  };

  toggleFilters = () => {
    this.setState({
      showFilters: !this.state.showFilters,
    });
  };

  fireGaEvents = () => {
    const gadata = {
      gaCategory: WEB_INDIA_HP_GA_CAT,
      gaAction: 'CoronavirusWidget_Actions',
      gaLabel: '/coronavirus',
    };
    sendGaThroughProps({ data: gadata });
  };

  render() {
    const { data: { path = '' } } = this.props;
    const { apiData, filterList, showFilters } = this.state;
    if (typeof apiData !== 'object' || !Array.isArray(filterList)) {
      return null;
    }
    const activeFilter = this.getActiveFilter();
    return (
      <div className={s.corona_counter_widget}>
        <div className={s.column}>
          <div className={s.head_dd}>
            <h3>COVID-19 Cases</h3>
            <div className={s.dd_region} onClick={this.toggleFilters}>
              {activeFilter.title || ''}
            </div>
            {showFilters &&
              filterList instanceof Array && (
                <ul>
                  {filterList.map(filter => (
                    <li
                      onClick={e => this.onFilterSelect(e, filter.title)}
                      className={filter.active && s.active}
                    >
                      {filter.title}
                    </li>
                  ))}
                </ul>
              )}
          </div>
        </div>
        <div className={`${s.column} ${s.column_number}`}>
          <div className={s.number_cases}>
            <div className={s.heading}>Confirmed </div>
            <div className={s.numbers}>
              {getValueBeforeDecimal(apiData.Confirmed)}
            </div>
          </div>
          <div className={s.number_cases}>
            <div className={s.heading}>Total Deaths </div>
            <div className={s.numbers}>
              {getValueBeforeDecimal(apiData.Deaths)}
            </div>
          </div>
          <div className={s.number_cases}>
            <div className={s.heading}>Recovered </div>
            <div className={s.numbers}>
              {getValueBeforeDecimal(apiData.Recovered)}
            </div>
          </div>
          <div className={`${s.number_cases} ${s.active_case}`}>
            <div className={s.heading}>
              Active Cases<i>i</i>
              <div className={s.warn_text}>
                Active cases refer to the total number of cases minus the number
                of cases that have recovered / died
              </div>
            </div>
            <div className={s.numbers}>
              {getValueBeforeDecimal(apiData.Active)}
            </div>
          </div>
        </div>
        <div className={`${s.column} ${s.column_last}`}>
          {typeof path === 'string' && (
            <a
              href={path}
              target="_blank"
              rel="noreferrer"
              className={s.btn}
              onClick={this.fireGaEvents}
            >
              Full Coverage <i />
            </a>
          )}
        </div>
      </div>
    );
  }
}
CoronaWidget.propTypes = {
  data: PropTypes.shape({}).isRequired,
  isMobile: PropTypes.bool,
};
CoronaWidget.defaultProps = {
  isMobile: false,
};

const mapStateToProps = state => ({
  isMobile: state.isMobile,
});
export default connect(mapStateToProps)(CoronaWidget);
